<template>
    <div>
        <div id="header" class="html-head clearfix fiex">
            <div class="page-container">
                <div class="nav_warp">
                    <div class="login-area" :class="{ 'mobile-menu-open': showMobile }">
                        <ul class="header-login clearfix">
                            <li class="shop-cart">
                                <div class="burger" @click="showMobile = !showMobile">
                                    <div class="burger-menu">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="logo" @click="goHome">
                        <div class="logo_img fl">
                            <img class="logo_val app_img" src="../assets/logo.png" alt="logo" srcset="">
                        </div>
                        <!-- <div class="logo_img f2 txt">
                            <h2>徐州地铁集团</h2>
                        </div> -->
                    </div>
                    <div class="login-area" :class="{ 'txt_right': hasLogin }">
                        <ul class="header-unlogin clearfix" v-if="!hasLogin">
                            <li class="shop-cart" id="shop-cart">
                                <a href="javascript:;" @click="loginDo" class="log_txt" id="js-signin-btn">登录/注册</a>
                            </li>
                        </ul>
                        <div class="tx_img" v-else @click="$router.push('/user')">
                            <el-image :src="user.avatar" fit="cover" style="width: 100%;height: 100%;border-radius: 50%;">
                                <div slot="error" class="image-slot" style="font-size: 20px;">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 62px;"></div>

        <!-- 菜单 -->
        <van-popup v-model:show="showMobile" position="right" :style="{ height: '100vh', width: '250px' }">
            <div class="pre-panel pre-panel-root">
                <ul class="pre-link-list">
                    <li class="pre-link-item" @click="toFun(item)" v-for="(item, index) in menuList" :key="index">
                        <a class="pre-link-label" href="javascript:;">{{ item.name }}</a>
                        <i class="iconfont icon-youjiantou"></i>
                    </li>
                    <li class="pre-link-item" v-if="hasLogin" @click="toFun({
                        name: '退出登录',
                        icon: 'icon-yijianfankui',
                        path: 'quit'
                    })">
                        <a class="pre-link-label" href="javascript:;">退出登录</a>
                        <i class="iconfont icon-youjiantou"></i>
                    </li>
                </ul>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast } from "vant";
export default {
    name: 'Header',
    computed: {
        ...mapState(['user', 'hasLogin'])
    },
    data() {
        return {
            showMobile: false,
            menuList: [{
                name: '首页',
                icon: 'icon-zhengshu',
                path: '/'
            }, {
                name: '课程中心',
                icon: 'icon-zhengshu',
                path: '/course'
            }, {
                name: '在线考试',
                icon: 'icon-zhengshu',
                path: '/examination'
            }, {
                name: '通知公告',
                icon: 'icon-quanbudingdan',
                path: '/announcement'
            }, {
                name: '个人中心',
                icon: 'icon-dangan1',
                path: '/user'
            }]
        }
    },
    mounted() {
    },
    methods: {
        toFun(item) {
            this.showMobile = false;
            if (item.path == 'quit') {// 退出登录
                this.$store.dispatch('LogOut').then(() => {
                    Toast('退出成功!');
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            } else {
                this.$router.push(item.path);
            }
        },
        loginDo() {
            this.$router.push('/login');
        },
        goHome() {
            this.$router.push('/');
        },
        registerTo() {
            this.$router.push('/register');
        },
        userTo() {
            this.$router.push('/userCenter_mc/profile');
        },
        quitFun() {
            this.$confirm('确定退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('LogOut').then(() => {
                    this.$message({
                        type: 'success',
                        message: '退出成功!'
                    });
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })

            })
        }
    }
}
</script>

<style lang="scss" scoped>
.fiex {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
}

#header {
    width: 100%;
    background-color: #ffffff;
    overflow: hidden;


    .page-container {
        width: 100%;
        z-index: 900;
        position: relative;

        .nav_warp {
            height: 60px;
            margin: 0 auto;
            padding: 0 0;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;

            .logo {
                height: 60px;
                display: flex;
                align-items: center;

                .txt {
                    position: relative;

                    h2 {
                        font-size: 18px;
                        color: #333;
                    }
                }

                .app_img {
                    position: relative;
                    top: 3px;
                    width: 120px;
                    // height: 26px;
                    margin-right: 5px;
                }

                .f1 {
                    float: left;
                }

                .f2 {
                    float: right;
                }
            }
        }
    }

    .logo {
        height: 60px;
        cursor: pointer;
    }

    .login-area {
        width: 90px;
        position: relative;
        color: #333333;
        display: flex;
        align-items: center;
        height: 100%;

        .header-login>li {
            float: left;
            padding: 0 12px;
            box-sizing: border-box;
            font-size: 18px;
            display: flex;
            align-items: center;
            height: 60px;
            line-height: 151px;

            a {
                align-items: center;
                height: 60px;
                line-height: 60px;

                .tx_img {
                    width: 35px;
                    height: 35px;
                    margin-right: 10px;
                }

                &.quit {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 119px;
                    height: 33px;
                    border: 2px solid #ffffff;
                    border-radius: 4px;
                }
            }
        }

        .header-unlogin>li {
            float: left;
            padding: 0 6px;
            box-sizing: border-box;
            font-size: 14px;

            a {
                height: 60px;
                line-height: 60px;
            }
        }

        .iconfont {
            margin-right: 10px;
            font-size: 14rem;
        }
    }
}

.log_txt {
    padding-left: 10px;
}

.burger {
    display: flex;
    position: absolute;
    right: 26px;
    top: 8px;
    width: 64px;
    height: 48px;
    align-items: center;
    justify-content: center;
}

.burger .burger-menu {
    display: block;
    width: 24px;
}

.mobile-menu-open .burger-menu span {
    opacity: 1;
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

.burger .burger-menu span {
    width: 18px;
    height: 2px;
    display: block;
    margin: 0 auto 5px;
    position: relative;
    background-color: #333333;
    border-radius: 3px;
    z-index: 1;
    -ms-transform-origin: 19px;
    transform-origin: 19px;
    transition: background .4s cubic-bezier(0.77, 0.2, 0.05, 1), opacity .45s ease, transform .4s cubic-bezier(0.77, 0.2, 0.05, 1), width .4s;
}

.mobile-menu-open .burger-menu span:nth-child(2) {
    width: 0;
    opacity: 0;
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
    transition: width .5s ease;
}

.mobile-menu-open .burger-menu span:last-child {
    opacity: 1;
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.pre-panel {
    padding: 0 20px;
    position: absolute;
    left: 0;
    right: 0;
    transform: translateX(0);
    transition: transform .25s;
    padding-bottom: 0;
}

.pre-link-list .pre-link-item {
    position: relative;
    padding: 20px 0;
}

.pre-link-item .pre-link-label {
    display: block;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    font-weight: 400;
}

.pre-link-list .pre-link-item::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: #979797;
    transform: scaleY(.5);
}

.pre-link-item .iconfont {
    position: absolute;
    top: 50%;
    margin-top: -10px;
    right: 5px;
    font-size: 14px;
}

.txt_right {
    text-align: right;
    justify-content: flex-end;
    padding-right: 20px;
}

.tx_img {
    width: 40px;
    height: 40px;
    border-radius: 20px;
}
</style>
